import printReportAction from '@/components/nsw-components/PrintReportsAction';

export default {
	gridactions: [printReportAction.printReport('DISTRESS_ALERTS_SITREP_REPORT', 'sitrepid', 'reports.label.distressalertssitrep')],
	formactions: [printReportAction.printReport('DISTRESS_ALERTS_SITREP_REPORT', 'sitrepid', 'reports.label.distressalertssitrep')]
};
